import { render, staticRenderFns } from "./charging-course.vue?vue&type=template&id=4da8f631&scoped=true"
import script from "./charging-course.vue?vue&type=script&lang=js"
export * from "./charging-course.vue?vue&type=script&lang=js"
import style0 from "./charging-course.vue?vue&type=style&index=0&id=4da8f631&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da8f631",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da8f631')) {
      api.createRecord('4da8f631', component.options)
    } else {
      api.reload('4da8f631', component.options)
    }
    module.hot.accept("./charging-course.vue?vue&type=template&id=4da8f631&scoped=true", function () {
      api.rerender('4da8f631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/charging-course.vue"
export default component.exports